"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import EmailMergerWrapper from "../email_merger_wrapper";
import configureStore from "../redux/configure_store";
const EMAIL_ID_ATTR = "email-id";
const CARRIER_ID_ATTR = "carrier-id";
const TAG = "ht-email-merger";
class EmailMergerElement extends HTMLElement {
  constructor() {
    super(...arguments);
    __publicField(this, "store", configureStore());
  }
  static get observedAttributes() {
    return [EMAIL_ID_ATTR, CARRIER_ID_ATTR];
  }
  connectedCallback() {
    this.renderFromAttributes();
  }
  attributeChangedCallback(name) {
    if (name === EMAIL_ID_ATTR || name === CARRIER_ID_ATTR) {
      this.renderFromAttributes();
    }
  }
  disconnectedCallback() {
    ReactDOM.unmountComponentAtNode(this);
  }
  renderFromAttributes() {
    const emailId = this.getAttribute(EMAIL_ID_ATTR);
    if (!emailId) return;
    const carrierId = this.getAttribute(CARRIER_ID_ATTR) || "";
    ReactDOM.render(
      React.createElement(
        Provider,
        { store: this.store },
        React.createElement(EmailMergerWrapper, {
          emailId: parseInt(emailId, 10),
          carrierId,
          mergeComplete: () => {
            this.dispatchEvent(
              new CustomEvent("merge-complete", { bubbles: true })
            );
          },
          onCancel: () => {
            this.dispatchEvent(
              new CustomEvent("merge-cancelled", { bubbles: true })
            );
          }
        })
      ),
      this
    );
  }
}
if (!customElements.get(TAG)) {
  customElements.define(TAG, EmailMergerElement);
}
